import {observer} from "mobx-react";
import HeaderMenu, {HeaderMenuOption} from "../header-menu/header-menu";
import {FONT_COLOR} from "../../../../fonts/font-props";
import FontBody1 from "../../../../fonts/font-body1/font-body1";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import AHref from "../../../../ahref/ahref";
import Icon from "../../../../icons/icon/icon";
import IconChatBubble from "./icons/icon-chat-bubble";
import IconBook from "./icons/icon-book";
import IconMegaphone from "./icons/icon-megaphone";
import IconSchedule from "./icons/icon-schedule";
import IconQuestion from "./icons/icon-question";
import dashboardSettingsStore from "../../../../../stores/dashboard-settings-store";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";
import { PROFILE_CAPABILITIES } from "../../../../../models/ProfileCapabilities";

import "./help-center-menu.scss";


const DASHBOARD_HOME_SCOPE = 'dashboard-home';
const DASHBOARD_SIDE_MENU_SCOPE = 'dashboard-side-menu';

const HelpCenterMenu = observer(() => {
    const {getTranslation} = useDashboardTranslation();

	const supportCapability = dashboardSettingsStore.resolveCapability(PROFILE_CAPABILITIES.SUPPORT);

    return (
        <HeaderMenu
            toggleContents={<Icon Component={IconQuestion} />}
            className="help-center-menu__toggle"
            onToggle={() => rmsMixpanelStore.trackEvent('d&_header_help_center')}
        >
            <div className="help-center-menu">
	            {supportCapability.chatMethod === 'chat' ? (
		            <HeaderMenuOption onClick={() => rmsMixpanelStore.trackEvent('d&_header_help_center_chat')}>
			            <div className="help-center-menu__open-chat" onClick={() => {
				            dashboardSettingsStore.openChat();
			            }}>
				            <Icon Component={IconChatBubble} />
				            <FontBody1 color={FONT_COLOR.PRIMARY2}>
					            {getTranslation('CHAT_WITH_US', DASHBOARD_HOME_SCOPE)}
				            </FontBody1>
			            </div>
		            </HeaderMenuOption>
	            ) : (
		            <HeaderMenuOption onClick={() => rmsMixpanelStore.trackEvent('d&_header_help_center_chat')}>
			            <AHref href={supportCapability.chatMethodUrl || ''} target="_blank">
				            <Icon Component={IconChatBubble} />
				            <FontBody1 color={FONT_COLOR.PRIMARY2}>
					            {getTranslation('CHAT_WITH_US', DASHBOARD_HOME_SCOPE)}
				            </FontBody1>
			            </AHref>
		            </HeaderMenuOption>
	            )}
                <HeaderMenuOption onClick={() => rmsMixpanelStore.trackEvent('d&_header_help_center_knowledge_base')}>
                    <AHref href="https://returngo.ai/go/knowledge-base" target="_blank">
                        <Icon Component={IconBook} />
                        <FontBody1 color={FONT_COLOR.PRIMARY2}>
                            {getTranslation('KNOWLEDGE_BASE', DASHBOARD_SIDE_MENU_SCOPE)}
                        </FontBody1>
                    </AHref>
                </HeaderMenuOption>
                <HeaderMenuOption onClick={() => rmsMixpanelStore.trackEvent('d&_header_help_center_whats_new')}>
                    <AHref href="https://returngo.ai/release-notes" target="_blank">
                        <Icon Component={IconMegaphone} />
                        <FontBody1 color={FONT_COLOR.PRIMARY2}>
                            {getTranslation('WHATS_NEW', DASHBOARD_SIDE_MENU_SCOPE)}?
                        </FontBody1>
                    </AHref>
                </HeaderMenuOption>
                {supportCapability.allowOnboardingCallBooking && (
                    <HeaderMenuOption onClick={() => rmsMixpanelStore.trackEvent('d&_header_help_center_book_call')}>
                        <AHref href="https://meetings.hubspot.com/returngo/onboarding-session" target="_blank">
                            <Icon Component={IconSchedule} />
                            <FontBody1 color={FONT_COLOR.PRIMARY2}>
                                Book an Onboarding call
                            </FontBody1>
                        </AHref>
                    </HeaderMenuOption>
                )}
            </div>
        </HeaderMenu>
    )
});

export default HelpCenterMenu;